import { useParams } from "react-router-dom";
import ReportDom from "../../../components/common/ReportDom";
import QuotationVoucherBody from "./QuotationVoucherBody";

export default function PrintQuotationVoucher() {
  const { id } = useParams();

  if (!id) return null;

  return (
    <div
      className="puppeteer-print-page"
      style={{
        background: "#fff",
        padding: 0,
      }}
    >
      <ReportDom
        renderTable={() => (
          <QuotationVoucherBody
            id={id}
            printMode
          />
        )}
      />
    </div>
  );
}